import { render, staticRenderFns } from "./localesFilters.vue?vue&type=template&id=8f13fad2"
import script from "./localesFilters.vue?vue&type=script&lang=js"
export * from "./localesFilters.vue?vue&type=script&lang=js"
import style0 from "./localesFilters.vue?vue&type=style&index=0&id=8f13fad2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports